import { Color } from "@starrez/starryui";
import styled from "styled-components";

export interface IFormRowProps {
    NoMargin?: boolean;
}

export interface IFormWrapperProps {
    SpaceBefore?: boolean;
}

export const FormWrapper = styled.div<IFormWrapperProps>`
    margin-top: ${(props: IFormWrapperProps) => props.SpaceBefore ? "48px" : "0"};
    margin-right: auto;
    margin-left: auto;
    max-width:800px;
    width: 100%;

    label[for] {
        font-weight: 700;
    }
`;

export const FormRow = styled.div<IFormRowProps>`

    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;

    margin: ${(props: IFormRowProps) => props.NoMargin ? "0" : "0 0 30px 0"};

    > :not(:first-child) {
        margin-left:10px;
    }
`;

export const FormRowInput = styled.div`
    flex: 1;
`;

export const FormTitleH2 = styled.h2`
    font-size: 1.5em;
    font-weight: 700;
    margin-bottom: 48px;
`;

export const FormSubTitleSpan = styled.span`
    &&& {color: ${Color.Grey.G100};
        display: block;
        font-weight: normal;
        font-size: 12px;
        margin-top: 8px;
    }
`;

export const FormFieldSet = styled.fieldset`
    border: none;
`;
